<template>
  <div class="tabs-nav-container" v-if="tabs.length > 0">
    <ul class="nav nav-pills nav-pills-primary" role="tablist">
      <li class="nav-item" v-for="tab in tabs" :key="tab.path">
        <router-link
          :to="tab.path"
          class="nav-link"
          :class="{ active: isActive(tab.path) }"
        >
          <span class="d-none d-sm-block">{{ tab.name }}</span>
          <span class="d-block d-sm-none">
            <i v-if="tab.icon" :class="tab.icon"></i>
            <span v-else>{{ tab.name }}</span>
          </span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TabsNav',
  props: {
    section: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    tabs() {
      const tabsConfig = {
        products: [
          { name: this.$t('Store'), path: '/products/dashboard' },
          { name: this.$t('Types'), path: '/products/types' },
          { name: this.$t('Packages'), path: '/products/packages' },
          { name: this.$t('Coupons'), path: '/products/coupons' }
        ],
        orders: [
          { name: this.$t('Active'), path: '/orders/dashboardActive' },
          { name: this.$t('Pending'), path: '/orders/dashboardPending' },
          { name: this.$t('Processing'), path: '/orders/dashboardProcessing' },
          { name: this.$t('Details'), path: '/orders/dashboardToDetails' },
          { name: this.$t('Stopped'), path: '/orders/dashboardStopped' },
          { name: this.$t('To Stop'), path: '/orders/dashboardToStop' },
          { name: this.$t('Canceled'), path: '/orders/dashboardCanceled' }
        ],
        payments: [
          { name: this.$t('Processing'), path: '/payments/dashboardCheck' },
          { name: this.$t('New'), path: '/payments/dashboardNew' },
          { name: this.$t('Paid'), path: '/payments/dashboardPaid' },
          { name: this.$t('Pending'), path: '/payments/dashboardPending' },
          { name: this.$t('Declined'), path: '/payments/dashboardDeclined' },
          { name: this.$t('Chargeback'), path: '/payments/dashboardChargeback' },
          { name: this.$t('Error'), path: '/payments/dashboardError' },
          { name: this.$t('Canceled'), path: '/payments/dashboardCanceled' }
        ],
        accounting: [
          { name: this.$t('Dashboard'), path: '/accounting/reports' },
          { name: this.$t('Transactions'), path: '/accounting/dashboard' },
          { name: this.$t('Add Expense'), path: '/accounting/addExpense' },
          { name: this.$t('Add Income'), path: '/accounting/addIncome' }
        ],
        marketing: [
          { name: this.$t('Analytics'), path: '/marketing/analytics' },
          { name: this.$t('Campaign'), path: '/marketing/campaign/dashboard' },
          { name: this.$t('Reminders'), path: '/marketing/reminders' }
        ],
        system: [
          { name: this.$t('Announcements'), path: '/system/announcements' },
          { name: this.$t('Payments'), path: '/system/payments' },
          { name: this.$t('Users'), path: '/system/users' },
          { name: this.$t('Import'), path: '/system/import' },
          { name: this.$t('Export'), path: '/system/export' },
          { name: this.$t('Clean'), path: '/system/clean' },
          { name: this.$t('2FA'), path: '/system/twofa' },
          { name: this.$t('Settings'), path: '/system/settings' },
          { name: this.$t('Online Users'), path: '/system/onlineusers' },
          { name: this.$t('Email Templates'), path: '/system/emailtemplates' },
          { name: this.$t('Audit Logs'), path: '/system/audit-logs' }
        ]
      };
      return tabsConfig[this.section] || [];
    }
  },
  methods: {
    isActive(path) {
      const currentPath = this.$route.path;
      // Direct match or child path
      if (currentPath === path || currentPath.startsWith(path + '/')) {
        return true;
      }
      // Special case: settingsEdit should highlight Settings tab
      if (path === '/system/settings' && currentPath === '/system/settingsEdit') {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.tabs-nav-container {
  margin-bottom: 20px;
  padding: 15px 0;
}

.nav-pills-primary .nav-link {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  border-radius: 30px;
  padding: 10px 20px;
  margin-right: 8px;
  transition: all 0.3s ease;
}

.nav-pills-primary .nav-link:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.nav-pills-primary .nav-link.active {
  background: linear-gradient(90deg, #e14eca 0%, #ba54f5 100%);
  color: #fff;
  box-shadow: 0 4px 15px rgba(225, 78, 202, 0.4);
}
</style>
